module.exports = __webpack_public_path__ + "img/voucher_10.5f1cd54c.jpg";